































































import { Component, Prop, Watch } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import { HeaderList, List } from '@/components/Table/TableModel';
import DateUtils from '@/utils/DateUtils';
import OfferFreeCoinsService from '@/api/OfferFreeCoinsService';
import { Campaign } from '@/models/marketingCenter/freeCoins';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import eventBus from '@/utils/eventBus';

import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    Typography,
    Table,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon
  }
})
export default class CampaignCustomers extends BasePagination {
  @Prop() campaign!: Campaign;
  @Prop() loading!: boolean;
  offerFreeCoinsService: OfferFreeCoinsService = new OfferFreeCoinsService();
  customers: List = new List([], []);
  searchableFields = 'searchableFields=customer.name';
  targetClassForInfineScroll = '.container-scrollable';

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get merchantDashboardReportsIsActivated() {
    return this.flags.includes(flagKeys.merchantDashboardReports);
  }

  get title() {
    return 'Members who claimed your Welcome Coins';
  }

  detail(rowData: any) {
    this.$analytics({
      eventCategory: 'Free Coins Campaign Detail | Customer click',
      eventAction: 'click',
      eventLabel: 'Went to the customer detail'
    });

    if (!this.merchantDashboardReportsIsActivated) {
      const modalConfig = {
        isOpen: true,
        component: 'customerDetails',
        data: rowData,
        secondaryStyle: true
      };

      eventBus.$emit('setSideModalVisible', modalConfig);

      return;
    }

    this.$router.push(`/performance/customer-center/${rowData.id}`);
  }

  mounted() {
    this.initHeader();
  }

  @Watch('campaign')
  reloadList(clearList?: boolean, refreshCurrent?: boolean, query?: string) {
    if (clearList) {
      this.resetPagination();
      this.customers.list = [];
      this.maxItems = false;
    }

    if (this.refreshing || this.maxItems || !this.campaign.id) return;

    this.$showLoaderWithLocker();
    this.refreshing = true;
    this.offerFreeCoinsService
      .listOfferFreeCoinsCustomers(this.campaign.id || '', {
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.query
      })
      .then((response: any) => {
        const { items, links } = response.data;
        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.pagination = links.next;
          if (!links.next) this.maxItems = true;
          this.customers.list = this.addRowsCustomers(items);
          this.isLoading = false;
        } else {
          // refresh page and add items
          this.customers.list = this.customers.list.concat(
            this.addRowsCustomers(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = links.next;
        }
      })
      .finally(() => {
        this.$hideLoader();
        this.isLoading = false;
        this.refreshing = false;
      });
  }

  initHeader() {
    const header: HeaderList[] = [
      new HeaderList(`Picture`, 'none', '12px 12px 12px 32px'),
      new HeaderList(`Member name`, 'customer.name', '0'),
      new HeaderList(`Lifetime spent`, 'lifetimeSpent'),
      new HeaderList(`Available balance`, 'availableCoins'),
      new HeaderList(`Collected in`, 'updatedAt'),
      new HeaderList('', 'none', '12px')
    ];
    this.customers.header = header;
  }

  addRowsCustomers(customersList: any[]): any[] {
    let rows: any[] = [];

    customersList.forEach((row: any) => {
      const customer = row.customer;
      const reward = Number(customer.freeCoinsRedeemed);
      rows.push({
        ...customer,
        name: customer.name + ' ' + customer.lastname,
        balance: Number(customer.availableCoins),
        reward: customer.availableCoins,
        coins: customer.availableCoins + reward,
        updatedAt: DateUtils.formattedDate({
          date: row.updatedAt
        }),
        spent: Number(customer.lifetimeSpent),
        picture: customer.image.id
          ? customer.image.publicPath.small
          : `${customer.name[0]}${customer.lastname[0]}`,
        joined: DateUtils.formatISOLongDate(customer.createdAt, false, true),
        visits: customer.totalVisits || '0'
      });
    });
    return rows;
  }

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  created() {
    eventBus.$on('reloadCampaignCustomers', this.reloadList);
  }

  beforeDestroy() {
    eventBus.$off('reloadCampaignCustomers', this.reloadList);
  }
}
